import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager();
import border from '@/components/border/borderType'; // 达标率

import standard from '@/components/env-bigData/standard'; // 水质数据

import waterFourPie from '@/components/env-bigData/waterFourPie';
import waterTwoRowPie from '@/components/env-bigData/waterTwoRowPie'; // 站点分类

import ratio from '@/components/env-bigData/ratio1'; // 设计处理能力

import siteTotalPie from '@/components/env-bigData/siteTotalPie'; // 七日预警统计

import warnAnalysis from '@/components/env-bigData/warnAnalysis'; // 站点在线、达标率

import threeAnalysis from '@/components/env-bigData/threeAnalysis'; // 统计区域数据时间轴柱状图

import areaBarAnalysis from '@/components/env-bigData/areaBarAnalysis'; // 区域分析

import areaDataAnalysis from '@/components/env-bigData/areaDataAnalysis';
import mapTag from '@/views/dashboard/com/mapTag';
import { mainRealtime, queryStandardTreeList, queryRankSkylist, queryWastDateList, queryRealWaterDateList, queryBigDataById, queryDateSkylist, queryWarn, querySiteBySt, querywastePollution, sumSt52Quota, queryAreaInfo, queryPipeSystem, queryManholeCover, mojiAqi } from '@/api/api';
import { getAction } from '@/api/manage';
import imgUrl from '@/assets/others/index/bg.gif';
import Earth from '@/components/Map/earth'; // 格式化数值插件

import accounting from 'accounting';
import moment from 'moment';
export default {
  components: {
    Earth: Earth,
    waterFourPie: waterFourPie,
    waterTwoRowPie: waterTwoRowPie,
    border: border,
    standard: standard,
    ratio: ratio,
    siteTotalPie: siteTotalPie,
    warnAnalysis: warnAnalysis,
    threeAnalysis: threeAnalysis,
    areaBarAnalysis: areaBarAnalysis,
    areaDataAnalysis: areaDataAnalysis,
    mapTag: mapTag
  },
  data: function data() {
    return {
      labelState: false,
      district: null,
      citys: [],
      leftDataObj: {},
      rightDataObj: {},
      // 今日数据
      today: [{
        name: '进水量',
        value: 0,
        unit: 'm³'
      }, {
        name: '出水量',
        value: 0,
        unit: 'm³'
      }, {
        name: '用电总量',
        value: 0,
        unit: 'kW·h'
      }, {
        name: '吨水能耗',
        value: 0,
        unit: 'kW/T'
      }],
      // 汇总数据
      allData: [{
        name: '进水量',
        value: 0,
        unit: 'm³'
      }, {
        name: '出水量',
        value: 0,
        unit: 'm³'
      }, {
        name: '用电总量',
        value: 0,
        unit: 'kW·h'
      }, {
        name: '吨水能耗',
        value: 0,
        unit: 'kW/T'
      }],
      warnType: '',
      changeType: '0',
      onlineNum: 0,
      unlineNum: 0,
      Inter: null,
      warnList: [],
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      mapStyle: 'amap://styles/darkblue',
      //设置地图样式
      leftInfo: [{
        name: '受益户数',
        icon: 'team',
        value: '12964',
        unit: '户'
      }, {
        name: '设计处理能力',
        icon: 'flag',
        value: '2380',
        unit: '吨/天'
      }, {
        name: '管网长度',
        icon: 'global',
        value: '173045',
        unit: '米'
      }],
      waterFourPieWidth: '',
      waterFourPieHeight: '',
      areaBarAnalysisWidth: '',
      areaBarAnalysisHeight: '',
      leftInfoHeight: '',
      ratioWidth: '',
      ratioHeight: '',
      siteTotalPieWidth: '',
      siteTotalPieHeight: '',
      siteTotalPieTop: '',
      threeAnalysisWidth: '',
      threeAnalysisHeight: '',
      threeAnalysisTop: '',
      areaDataAnalysisWidth: '',
      areaDataAnalysisHeight: '',
      siteOnlineHeight: '',
      warnListWidth: '',
      warnListHeight: '',
      analysisWidth: '',
      analysisHeight: '',
      analysisTop: '',
      warnState: true,
      selectIndex: '',
      showState: true,
      standState: false,
      windows: [],
      window: '',
      standardList: [],
      markerList: [],
      // 水质分布数据
      standardMap: [],
      // 达标率
      compliant: 1,
      siteDetail: {},
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      time: [],
      labelData: [],
      pollutionData: [],
      amapManager: amapManager,
      center: [118.047928, 24.613341],
      zoom: 12,
      siteWarnList: [],
      mapSelectindex: 0,
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      pipeList: [],
      wellList: [],
      wellImg: require('@/assets/others/well.png'),
      pipeImg: require('@/assets/others/pipe.png'),
      pipeOffset: new AMap.Pixel(-20, -25),
      weatherInfo: {
        condition: "",
        humidity: "",
        temp: ""
      }
    };
  },
  watch: {
    warnType: function warnType(e) {
      this.getWarnList(e);
    }
  },
  filters: {
    formatterCost: function formatterCost(value) {
      return accounting.formatNumber(value, 2, ',');
    }
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'));
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resetWidth);
    clearInterval(this.Inter);
  },
  mounted: function mounted() {
    var _this = this;

    this.standardList = [{
      title: '处理站',
      value: 3,
      icon: 'icon-yiliaofeishui',
      show: true
    }, {
      title: '泵站',
      value: 1,
      icon: 'icon-bengzhan1',
      show: true
    }, {
      title: this.$store.state.projectCode == 'meitang' ? '化粪池' : '窨井',
      value: 4,
      icon: '',
      img: this.wellImg,
      show: true
    }, {
      title: '管网',
      value: 5,
      icon: '',
      img: this.pipeImg,
      show: true
    }];
    this.$nextTick(function () {
      setTimeout(function () {
        _this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;

        _this.getApi('52');

        _this.getPipeSystem();

        _this.getManholeCover(); // 获取社区概况数据


        _this.getDataList();
      }, 1000);
    }); //自适应

    this.resetWidth();
    this.getAqi();
    this.inter = setInterval(function () {
      _this.getAqi();
    }, 10 * 60 * 1000);
    window.addEventListener('resize', this.resetWidth, false);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.inter);
  },
  methods: (_methods = {
    handleData: function handleData(code, defaultUnit) {
      var dataString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'leftDataObj';
      var value = '--';
      var unit = defaultUnit;
      console.log('handleData', this[dataString][code]);

      if (this[dataString][code]) {
        value = this[dataString][code].value != null ? this[dataString][code].value : '--';
        unit = this[dataString][code].hasOwnProperty('factor') ? this[dataString][code].factor.unitName : defaultUnit;
      }

      return "".concat(value, " ").concat(unit);
    },
    getDataList: function getDataList() {
      var _this2 = this;

      queryWastDateList({
        scopeId: 2,
        type: 1,
        st: 52,
        scope: 1
      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var factorObj = res.result.records[0].factor;
          res.result.query.factors.forEach(function (item) {
            if (factorObj[item.code]) {
              factorObj[item.code]['factor'] = item;
            }
          });
          console.log('factorObj', factorObj);
          _this2.leftDataObj = factorObj;
        }
      });
      queryWastDateList({
        scopeId: 17,
        type: 1,
        st: 52,
        scope: 1
      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var factorObj = res.result.records[0].factor;
          res.result.query.factors.forEach(function (item) {
            if (factorObj[item.code]) {
              factorObj[item.code]['factor'] = item;
            }
          });
          _this2.rightDataObj = factorObj;
        }
      });
    },
    // 获取aqi数据
    getAqi: function getAqi() {
      var _this3 = this;

      console.log('mojiAqi', this.center);
      mojiAqi({
        lat: this.center[1],
        lon: this.center[0]
      }).then(function (res) {
        if (res.success) {
          _this3.weatherInfo = res.result.condition;
        }
      });
    },
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.lines = lines;
            item.show = true;
            return item;
          });
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var _this4 = this;

      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              show: true,
              content: "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this4.wellImg, "\" />"),
              events: function events() {// 点击窨井盖
              }
            };
          });
        }
      });
    },
    onToChangeLabel: function onToChangeLabel() {
      this.labelState = !this.labelState;
      console.log('this.labelState', this.labelState);
      this.initMarker();
    },
    initMarker: function initMarker() {
      var _this5 = this;

      console.log('markerList', this.markerList);
      this.markerList.forEach(function (item) {
        if (_this5.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          };
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          };
        }
      });
    },
    drawBounds: function drawBounds(type) {
      var map = amapManager.getMap();
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: type == 1 ? 'rgba(0,0,0)' : 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: type == 1 ? 0.5 : 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    // 获取日报数据
    getDateList: function getDateList(scopeId) {
      var _this6 = this;

      queryWastDateList({
        scopeId: scopeId,
        type: 1,
        st: 52,
        scope: 1
      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          _this6.dateList = res.result.query.factors;
        }
      });
    },
    getSumSt52Quota: function getSumSt52Quota(dateType) {
      var that = this;
      sumSt52Quota({
        // scope: 2,
        // scopeId: 45,
        dateType: dateType
      }).then(function (res) {
        if (res.success) {
          if (dateType == 0) {
            var data1;

            if (res.result.waterInlet && res.result.electConsum) {
              data1 = res.result.waterInlet != 0 ? res.result.electConsum / res.result.waterInlet : 0;
            } else {
              data1 = 0;
            }

            if (that.today) {
              that.today[0].value = res.result.waterInlet || 0;
              that.today[1].value = res.result.waterOutlet || 0;
              that.today[2].value = res.result.electConsum || 0;
              that.today[3].value = data1;
            }
          } else {
            var _data;

            if (res.result.waterInlet && res.result.electConsum) {
              _data = res.result.waterInlet != 0 ? res.result.electConsum / res.result.waterInlet : 0;
            } else {
              _data = 0;
            }

            if (that.allData) {
              that.allData[0].value = res.result.waterInlet || 0;
              that.allData[1].value = res.result.waterOutlet || 0;
              that.allData[2].value = res.result.electConsum || 0;
              that.allData[3].value = _data;
            }
          }
        }
      });
    },
    getLeftInfo: function getLeftInfo(res) {// this.leftInfo[0].value = res.result.servingPopulation
      // this.leftInfo[1].value = res.result.processingCapacity
      // this.leftInfo[2].value = res.result.pipeNetworkLength
    },
    changeMap: function changeMap() {
      var _this7 = this;

      if (this.plugin[0].defaultType) this.plugin[0].defaultType = 0;else this.plugin[0].defaultType = 1;
      this.mapControlindex = 1;
      this.window = null;
      this.$nextTick(function () {
        _this7.mapControlindex = 0;
        _this7.zoom = 15;
        setTimeout(function () {
          _this7.drawBounds(_this7.plugin[0].defaultType);
        }, 500);

        _this7.$nextTick(function () {
          // setTimeout(() => {
          _this7.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12; // }, 500)
        }); // this.changeVisible()

      });
    },
    // 获取对应标准的对应数据
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title.replace('类', '')) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    // 点击详情中的查看详情跳转
    ontoSite: function ontoSite() {
      var _this8 = this;

      sessionStorage.setItem('selectId', JSON.stringify(this.siteDetail));
      setTimeout(function () {
        _this8.$emit('siteTurn', true);
      }, 100);
    },
    // 重新渲染地图上的站点
    changeVisible: function changeVisible() {
      var _this9 = this;

      var arr = [];
      var windows = [];
      var that = this;
      that.markerList.forEach(function (item, index) {
        var position;
        if (item.longitude != 'NaN') position = [item.longitude, item.latitude];else position = _this9.center;
        item.position = position;
        item.show = true;
        var icon = 'icon-yiliaofeishui';

        if (item.upStandard) {
          item.content = _this9.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, icon);
          item.zIndex = 1000000;
        } else if (item.upStandard == null) {
          if (item.onlineStatus) {
            item.content = that.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, icon);
            item.zIndex = 1000000;
          } else {
            item.content = that.getWasteShape('#ccc', '', item.warnStatus, item.onlineStatus, item.name, icon);
            item.zIndex = 1;
          }
        } else {
          item.content = that.getWasteShape('red', '', item.warnStatus, item.onlineStatus, item.name, icon);
          item.zIndex = 1;
        }

        item.events = {
          click: function click() {
            that.windows.forEach(function (window) {
              window.visible = false; //关闭窗体
            });
            that.window = that.windows[index];
            that.$nextTick(function () {
              that.window.visible = true; //点击点坐标，出现信息窗体

              that.getsiteDetail(item.id); //获取对应id的站点详情
            });
          }
        }, arr = [];
        var positions;
        if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
        windows.push({
          position: positions,
          offset: [0, 0],
          //窗体偏移
          visible: false,
          //初始是否显示
          name: item.name,
          onlineStatus: item.onlineStatus,
          siteId: item.id
        });
      }); //加弹窗

      that.windows = windows;
    },
    // 点击路况
    onselectRoad: function onselectRoad() {
      var _this10 = this;

      this.roadSelectindex = !this.roadSelectindex; // this.$forceUpdate()
      // let a = this.$refs.maps.$$getInstance()

      if (this.plugin[0].showTraffic) this.plugin[0].showTraffic = false;else this.plugin[0].showTraffic = true;
      this.mapControlindex = 1;
      this.window = null;
      this.zoom = 15;
      this.$nextTick(function () {
        // this.changeVisible()
        _this10.mapControlindex = 0;
        setTimeout(function () {
          _this10.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        }, 1000);
      });
    },
    // 点击路网
    onselectNet: function onselectNet() {
      var _this11 = this;

      this.netSelectindex = !this.netSelectindex;
      if (this.plugin[0].showRoad) this.plugin[0].showRoad = false;else this.plugin[0].showRoad = true;
      this.mapControlindex = 1;
      this.window = null;
      this.zoom = 15;
      this.$nextTick(function () {
        // this.changeVisible()
        _this11.mapControlindex = 0;
        setTimeout(function () {
          _this11.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        }, 1000);
      });
    },
    // 点击卫星
    onselectMap: function onselectMap(index) {
      this.mapSelectindex = !this.mapSelectindex;
      this.changeMap();
    },
    // 获取各个站点数据
    getSite: function getSite(st) {
      var _this12 = this;

      var that = this;
      var param = st ? {
        st: st
      } : {};
      querySiteBySt(param).then(function (res) {
        if (res.success) {
          var arr = [];
          var windows = [];
          var onlineIndex = 0;
          var unlineIndex = 0;
          that.onlineNum = 0;
          res.result.forEach(function (item, index) {
            if (item.onlineStatus) {
              that.onlineNum++;
            }

            if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude];else item.position = ['118.04792', '24.61334'];
            item.show = true;
            item.title = item.name;
            item.offset = [0, -3];

            if (_this12.labelState) {
              item['label'] = {
                content: item.name,
                offset: [0, -20]
              };
            } else {
              item['label'] = {
                content: '',
                offset: [0, 0]
              };
            }

            var icon = 'icon-yiliaofeishui';
            if (item.category == 1) icon = 'icon-bengzhan1';

            if (item.upStandard) {
              item.content = _this12.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, icon);
              item.zIndex = 1000000;
            } else if (item.upStandard == null) {
              if (item.onlineStatus) {
                item.content = that.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, icon);
                item.zIndex = 1000000;
              } else {
                item.content = that.getWasteShape('#ccc', '', item.warnStatus, item.onlineStatus, item.name, icon);
                item.zIndex = 1;
              }
            } else {
              item.content = that.getWasteShape('red', '', item.warnStatus, item.onlineStatus, item.name, icon);
              item.zIndex = 1;
            }

            item.events = {
              click: function click() {
                that.windows.forEach(function (window) {
                  window.visible = false; //关闭窗体
                });
                that.window = that.windows[index];
                that.$nextTick(function () {
                  that.window.visible = true; //点击点坐标，出现信息窗体

                  that.getsiteDetail(item.id); //获取对应id的站点详情
                });
              }
            }, arr = [];
            var positions;
            if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
            windows.push({
              position: positions,
              offset: [6, -33],
              //窗体偏移
              visible: false,
              //初始是否显示
              name: item.name,
              onlineStatus: item.onlineStatus,
              siteId: item.id
            }); // return item
          });
          that.windows = windows;
          console.log('res.result', res.result);
          _this12.markerList = res.result;
        }
      });
    },
    // 获取到污染源类型的图标状态
    getWasteShape: function getWasteShape(bgColor, name, warnState, onlineState, siteName, icon) {
      var warnStyle = '';
      var onlineStyle = '';

      if (warnState) {
        warnStyle = '<img style=\'width:20px;height:20px;position:absolute;right:-14px;top:-10px;\' src=\'' + imgUrl + '\' />';
      }

      if (!onlineState) {
        bgColor = '#ccc'; // onlineStyle =
        // 	"<div class='iconfont icon-dacha' style='font-size:27px;position:absolute;left:4px;top:0;color:#fff;font-weight:400;'></div>"
      }

      return '<div style=\'position: relative;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: ' + bgColor + ';text-align: center;color: #000;line-height: 30px;cursor: pointer;\'><div style=\'width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:' + bgColor + '\'></div><div title=\'' + siteName + '\' style=\'position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:' + bgColor + ';text-align: center;color:#000;line-height: 30px;cursor: pointer;\'><div class=\'iconfont ' + icon + '\' style=\'font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;\'></div>' + name + warnStyle + onlineStyle + '</div></div>';
    },
    // 抽取公共渲染标准的方法
    standType: function standType(res) {
      var color = [];
      var title = [];
      var a = [];
      var colors = ['green', 'red'];
      var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]];

      if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
        if (res.result[date[0]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
        if (res.result[date[1]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
        if (res.result[date[2]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      this.$refs.dials.initBarChart(title, color, date, a, 2);
    },
    // 用于渲染没有数据时
    standFailtype: function standFailtype() {
      var _this13 = this;

      this.showDial = true;
      var date = new Date();
      var year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var year3 = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
      this.$nextTick(function () {
        _this13.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 2);
      });
    },
    // 获取实时水质标准
    getwaterStand: function getwaterStand(id) {
      var _this14 = this;

      getAction("/online/st/52/standardBySite", {
        scopeId: id,
        scope: 1
      }).then(function (res) {
        if (res.success) {
          var color = [];
          var title = [];
          var a = [];
          var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]];
          a.push(_this14.getStand(res.result[date[0]] ? res.result[date[0]].currentStandard : ''));
          a.push(_this14.getStand(res.result[date[1]] ? res.result[date[1]].currentStandard : ''));
          a.push(_this14.getStand(res.result[date[2]] ? res.result[date[2]].currentStandard : ''));

          if (res.result[date[0]] != null && res.result[date[0]].currentStandard != null) {
            color.push(res.result[date[0]].currentStandard.color);
            title.push(res.result[date[0]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          if (res.result[date[1]] != null && res.result[date[1]].currentStandard != null) {
            color.push(res.result[date[1]].currentStandard.color);
            title.push(res.result[date[1]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          if (res.result[date[2]] != null && res.result[date[2]].currentStandard != null) {
            color.push(res.result[date[2]].currentStandard.color);
            title.push(res.result[date[2]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          _this14.$refs.dials.initBarChart(title, color, date, a, _this14.standardList.length); // let arr = []
          // let color = []
          // if(res.result['同比标准']){
          // 	color.push()
          // }
          // color.push()

        } else {
          _this14.showDial = true;

          var _date = new Date();

          var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year3 = _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate();

          _this14.$nextTick(function () {
            _this14.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6);
          });
        }
      });
    },
    // 获取对应的day天前的日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate + ' ' + hour + ':' + minute + ':' + second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取对应点击的站点的站点详情
    getsiteDetail: function getsiteDetail(id) {
      var _this15 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        if (res.success) {
          res.result.photo = _this15.getImageView(res.result.photo);
          _this15.siteDetail = res.result;
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    resetWidth: function resetWidth() {
      this.$refs.ratioBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.ratioBorder.height = document.documentElement.clientHeight * 0.6;
      this.$refs.columnBorder.width = document.documentElement.clientWidth * 0.25;
      this.$refs.columnBorder.height = document.documentElement.clientHeight * 0.43; // this.$refs.warnBorder.width = document.documentElement.clientWidth * 0.45
      // this.$refs.warnBorder.height = document.documentElement.clientHeight * 0.15

      this.$refs.warnBorder1.width = document.documentElement.clientWidth * 0.25;
      this.$refs.warnBorder1.height = document.documentElement.clientHeight * 0.25;
      this.$refs.warnBorder2.width = document.documentElement.clientWidth * 0.25;
      this.$refs.warnBorder2.height = document.documentElement.clientHeight * 0.45;
      this.waterFourPieWidth = document.documentElement.clientWidth * 0.45 + 'px';
      this.waterFourPieHeight = document.documentElement.clientHeight * 0.15 + 'px';
      this.areaBarAnalysisWidth = document.documentElement.clientWidth * 0.2 + 'px';
      this.areaBarAnalysisHeight = document.documentElement.clientHeight * 0.5 + 'px';
      this.threeAnalysisWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.threeAnalysisHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.threeAnalysisTop = document.documentElement.clientHeight * 0.34 + 'px';
      this.areaDataAnalysisWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.areaDataAnalysisHeight = document.documentElement.clientHeight * 0.23 + 'px';
      this.siteOnlineHeight = document.documentElement.clientHeight * 0.02 + 'px';
      this.ratioWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.ratioHeight = document.documentElement.clientHeight * 0.23 + 'px';
      this.siteTotalPieWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.siteTotalPieHeight = document.documentElement.clientHeight * 0.23 + 'px';
      this.siteTotalPieTop = this.ratioHeight;
      this.warnListWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.warnListHeight = document.documentElement.clientHeight * 0.17 + 'px';
      this.analysisWidth = document.documentElement.clientWidth * 0.25 + 'px';
      this.analysisHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.analysisTop = document.documentElement.clientHeight * 0.23 + 'px';
      this.leftInfoHeight = document.documentElement.clientHeight * 0.13 + 'px';
    },
    close: function close() {
      this.window.visible = false;
    },
    getApi: function getApi(st) {
      var _this16 = this;

      this.showState = false;
      this.$nextTick(function () {
        _this16.showState = true;
        setTimeout(function () {
          _this16.getSite(st);

          _this16.getWarnList(_this16.warnType);

          _this16.getSumSt52Quota(0);

          _this16.getSumSt52Quota(2);

          _this16.getDateList(2);

          _this16.getDateList(3);

          _this16.drawBounds();
        }, 1000);
      });
    },
    selctTag: function selctTag(index, item) {
      console.log('item', item);
      console.log('markerList', this.markerList);
      item.show = !item.show;

      switch (item.value) {
        case 4:
          this.wellList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          break;

        case 5:
          this.pipeList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          break;

        default:
          this.markerList.forEach(function (item1, index1) {
            if (item1.category == item.value) {
              item1.show = item.show;
            }
          });
          break;
      } // if (index == this.standardList.length) {
      // 	this.markerList.forEach((item, index) => {
      // 		if (!item.currentStandard) {
      // 			item.show = !item.show
      // 		}
      // 	})
      // } else {
      // 	this.standardList[index].data.show = !this.standardList[index].data.show
      // 	this.markerList.forEach((item, index) => {
      // 		if (item.currentStandard) {
      // 			if (item.currentStandard.id == id) {
      // 				item.show = !item.show
      // 			}
      // 		}
      // 	})
      // }
      //  }

    }
  }, _defineProperty(_methods, "getStand", function getStand(data) {
    if (data) {
      for (var i = 0; i < this.standardList.length; i++) {
        if (this.standardList[i].data.title == data.title.replace('类', '')) {
          return i + 1;
        }
      }
    } else {
      return 0;
    }
  }), _defineProperty(_methods, "getWarnList", function getWarnList(category) {
    var _this17 = this;

    var startTime = moment().subtract(7, 'days').format('YYYY-MM-DD');
    var endTime = moment().format('YYYY-MM-DD');
    queryWarn({
      size: 20,
      current: 1,
      stime: startTime,
      warnStatus: 1,
      etime: endTime,
      category: category
    }).then(function (res) {
      if (res.success) {
        _this17.warnList = res.result.records;

        if (_this17.Inter) {
          clearInterval(_this17.Inter);
        }

        _this17.Inter = setInterval(function () {
          setTimeout(function () {
            if (_this17.warnList.length > 6) {
              _this17.warnList.push(_this17.warnList[0]); // 将数组的第一个元素添加到数组的


              _this17.warnList.shift(); //删除数组的第一个元素

            }
          }, 500);
        }, 3000);
      }
    });
  }), _methods)
};